import { useEffect, useState } from 'react';

import * as S from './style';

export function UseTerms() {
  const [isTermsAccepted, setIsTermsAccepted] = useState(true);
  function handleAcceptTerms() {
    setIsTermsAccepted(true);
    localStorage.setItem('@boratickets:isTermsAccepted', 'true');
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const termsFromLocalStorage = JSON.parse(
        localStorage.getItem('@boratickets:isTermsAccepted'),
      );
      if (termsFromLocalStorage) {
        setIsTermsAccepted(true);
      } else {
        setIsTermsAccepted(false);
      }
    }
  }, []);

  return (
    !isTermsAccepted && (
      <>
        <S.Container>
          <p>
            O site do Bora Tickets utiliza termos de uso, privacidade e política
            de compra para melhorar sua experiência de navegação em nossos
            serviços e recomendar nossos eventos de seu interesse. Ao continuar
            a utilizar nossos serviços, você concorda com nossos{' '}
            <a
              href="https://vendas.boratickets.com.br/legal/termos-uso"
              target="_blank"
              rel="noreferrer"
            >
              Termos de uso
            </a>
            ,{' '}
            <a
              href="https://vendas.boratickets.com.br/legal/politica-privacidade"
              target="_blank"
              rel="noreferrer"
            >
              privacidade
            </a>{' '}
            e{' '}
            <a
              href="https://vendas.boratickets.com.br/legal/politica-compras"
              target="_blank"
              rel="noreferrer"
            >
              política de compras
            </a>
            .
          </p>
          <S.Button onClick={handleAcceptTerms}>Aceito</S.Button>
        </S.Container>
      </>
    )
  );
}
